<template>
    <vs-popup class="chat_cont_popup" :title="$t('create_group_chat')" :active.sync="popupActive">
        <vx-input-group class="w-full  input-group-top">
                <vs-input
                    icon-no-border
                    icon="icon-search"
                    size="large"
                    :maxlength="inputMaxLimit"
                    icon-pack="feather"
                    :placeholder="$t('name_of_student')"
                    v-model.lazy="searchQuery"
                    class="vs-input-no-border vs-input-no-shdow-focus w-full" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            :key="updateClearSearchButton"
                            @click="clearSearch()"
                            color="dark"
                            type="flat"
                            class="rounded"
                            icon-pack="feather"
                            icon="icon-x">
                        </vs-button>
                    </div>
                </template>
        </vx-input-group>
        <component
            :is="'VuePerfectScrollbar'"
            ref="popupScroll"
            class="popupScroll scroll_cont_add"
            @ps-y-reach-end="getContactsList"
            :settings="settings"
            :key="$vs.rtl">
                <ul class="chat__active-chats bordered-items">
                    <li class="cursor-pointer" v-for="(contact, index) in contacts" :key="index">
                        <ChatContact :checkBoxMode="true" :contact="contact" />
                    </li>
                </ul>
                <div v-show="allContactStatus" class="vs-con-loading__container contact_popup_loader"></div>
        </component>
        <div class="mt-3 flex-wrap flex item-center flex-col-reverse lg:flex-row-reverse lg:justify-between" v-show="selectedContacts.length">
            <vs-button
                color="primary"
                class="create_loader mt-1 lg:mt-0"
                :disabled="disabledBtn"
                @click="createChat()"
                type="filled">
                    {{$t('create_group_chat2')}}
            </vs-button>
            <vs-input
                :disabled="disabledInput"
                class="lg:ml-2 w-full lg:w-auto b-solid"
                :placeholder="$t('chat_name')"
                v-model="chatName" />
        </div>
    </vs-popup>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import ChatContact from './ChatContact.vue'
import {mapState} from 'vuex'
export default {
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6
            },
            loading: false,
            inputMaxLimit:40,
            page: 0,
            chatName: '',
            searchQuery:'',
            updateClearSearchButton: 0,
        }
    },
    computed: {
        ...mapState({
            contacts: state => state.chat.contactsAll,
            allContactStatus: state => state.chat.allContactStatus,
            selectedContacts: state => state.chat.selectedContacts,
            moderate: state => state.chat.moderate
        }),
        disabledBtn() {
            if(this.selectedContacts.length > 1 && this.chatName.length)
                return false
            else
                return true
        },
        disabledInput() {
            if(this.selectedContacts.length > 1)
                return false
            else
                return true
        },
        popupActive: {
            get() {
                return this.$store.state.chat.contactPopup
            },
            set(val) {
                this.$store.commit('chat/SET_CONTACT_POPUP', val)
            }
        }
    },

    watch:{
        searchQuery(val){
            this.$store.commit('chat/CLEAR_CONTACTS');
            this.page = 0;
            this.getContactsList();
        },
        popupActive(isActive){
            if(!isActive){
                this.$store.commit('chat/SET_SELECTED_CONTACTS', [])
                this.chatName = ''
            }
        }
    },
    methods: {
        clearSearch(){
            this.searchQuery = ''
            // Чтобы кнопка поменяла цвет с черного
            this.updateClearSearchButton += 1

        },
        async createChat() {
            if(this.chatName.length >= 3) {
                let chat = {
                    members: [],
                    name: '',
                    is_public: false
                }

                this.selectedContacts.forEach(item => {

                    let member = {user: item}

                    if(this.selectedContacts.length > 1) {
                        if(this.moderate.length) {
                            const find = this.moderate.find(elem => elem === item)
                            if(find)
                                member.is_moderator = true
                            else
                                member.is_moderator = false
                        } else {
                            member.is_moderator = false
                        }
                    }

                    chat.members.push(member)
                })

                if(this.selectedContacts.length > 1) {
                    chat.is_public = true
                    chat.name = this.chatName
                } else
                    chat.name = chat.members[0].user

                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.create_loader',
                            scale: 0.6
                        })
                    })
                    const res = await this.$store.dispatch('chat/createChat', chat)
                    if(res) {
                        let query = Object.assign({}, this.$route.query)
                        query.id = res.id
                        this.$router.push({query})
                        this.$store.commit('chat/SET_OPEN_DIALOG', res)
                        this.$store.commit('chat/SET_TAB', 0)

                        this.clearPopup()
                    }
                } catch(e) {

                } finally {
                    this.$vs.loading.close('.create_loader > .con-vs-loading')
                }
            } else {
                this.$vs.notify({
                    text: this.$t('chat_name_min'),
                    color: 'warning'
                })
            }
        },
        clearPopup() {
            this.chatName = ''
            this.$store.commit('chat/SET_SELECTED_CONTACTS', [])
            this.$store.commit('chat/SET_MODERATE', [])
            this.popupActive = false
        },
        async getContactsList() {
            if(!this.loading && this.allContactStatus && this.popupActive) {
                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.contact_popup_loader',
                            background: 'transparent',
                            scale: 0.6
                        })
                    })
                    this.loading = true
                    this.page = this.page+1
                    const res = await this.$store.dispatch('chat/getContacts', {page: this.page, all: true,search:this.searchQuery})
                    if(!res.next)
                        this.$store.commit('chat/SET_ALL_CONTACT_STATUS', false)
                } catch(e) {

                } finally {
                    this.$vs.loading.close('.contact_popup_loader > .con-vs-loading')
                    this.loading = false
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar,
        ChatContact
    }
}
</script>

<style lang="scss">
.create_loader{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.contact_popup_loader{
    position: relative;
    padding: 20px 0;
    .con-vs-loading{
        position: absolute;
    }
}
@media only screen and (min-width: 893px) {
    .popupScroll{
        max-height: 312px;
    }
}
@media only screen and (max-width: 892px) {
    .popupScroll{
        &.scroll_cont_add{
            height: calc(100% - 90.59px);
        }
    }
}
</style>

<style scoped>
    .input-group-top{
        position: relative;
        top: -18px;
        border-bottom: 1px solid lightgrey;
    }


    .b-solid{
        border: 1px solid rgba(var(--vs-primary), 1);
        border-radius: 8px;
    }

    @media(min-width:990px){
        .b-solid{
            width:55% !important;
        }
    }
</style>
